"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
import { AccountSessionMixins } from "@/service/account-session";
export class EditVdNameForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.name = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("editvdnamedialog.name_cannot_be_empty"),
    trigger: "blur"
  }])
], EditVdNameForm.prototype, "name", 2);
let EditVdNameDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.row = {};
    this.dialogLoading = false;
    this.sync_shop_name = false;
    this.dialog = new UiDialogController();
    this.controller = new EditVdNameForm();
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth.pro/v1/virtual-desktops/${this.row.id}`, {
          "name": this.controller.name
        });
        this.$message.success(this.$t("editvdnamedialog.modified_successfully"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  open(row) {
    this.row = row;
    this.controller = new EditVdNameForm();
    this.controller.name = row.name;
    this.sync_shop_name = false;
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
};
EditVdNameDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], EditVdNameDialog);
export {
  EditVdNameDialog as default
};
